module.exports = __webpack_public_path__ + "img/mastercard.3d6b754.png";